import './Icon_Bell.css';
import { ReactComponent as BellIcon } from './Icons_Notifications_Outline_Brand.svg';
function Icon_Bell() {
  return (
    <div className='icon-container-bell'>
      <BellIcon className="responsive-svg-bell"/>
    </div>
  );
}

export default Icon_Bell;